import { useEffect, useRef, useState } from "react";
import { getOnePainting } from "../../api-route/painting.js";
import Article from "../../Components/DetailPaint/article";
import Aside from "../../Components/DetailPaint/aside";
import ArtSection from "../../Components/arts-section/index.section";
import { useLocation, useParams } from "react-router-dom";
import { BreadcrumbItem, Breadcrumbs } from "@nextui-org/react";
import { Helmet } from "react-helmet";
import React from "react";
import { BaseURL } from "../../config/axios.js";

export default function Page() {
  const main = useRef(null)
  const location = useLocation();
  const { slug } = useParams()
  const [Painting, setPainting] = useState()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [mainImage, setMainImage] = useState("")
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [passpartout, setPasspartout] = useState(null)

  useEffect(() => {
    const fetchPainting = async () => {
      if (!slug) return; // Ensure `slug` is defined

      try {
        const paintingData = await getOnePainting(slug);
        if (paintingData) {
          setPainting(paintingData);
          setMainImage(paintingData.mainImage); // Assuming `mainImage` is part of painting data
          setWidth(50);
        } else {
          setError("تابلو نقاشی پیدا نشد");
        }
      } catch (err) {
        setError("مشکل در بارگزاری اطلاعات");
      } finally {
        setLoading(false);
      }
    };

    fetchPainting();
  }, [slug]);

  if (loading) {
    return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;
  }

  if (error) {
    return <div className="centerOfParent h-screen w-full">{error}</div>;
  }

  if (!Painting) {
    return <div className="centerOfParent h-screen w-full">اطلاعات تابلو پیدا نشد</div>;
  }
  const generalSchema =
  {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": Painting?.title,
    "image": [
      mainImage || (Painting?.images[0] && BaseURL + Painting?.images[0].path),
    ],
    "description": Painting?.body?.replace(/<\/?[^>]+(>|$)/g, ""),
    "sku": `TPP-${Painting?.id}`,
    "offers": {
      "@type": "Offer",
      "priceCurrency": "IRR",
      "price": "99.99",
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition",
      "url": "https://example.com/product/123",
      "seller": {
        "@type": "Organization",
        "name": "tonaliteh"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.5",
      "reviewCount": "123"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "author": {
          "@type": "Person",
          "name": "John Doe"
        },
        "reviewBody": "This product is amazing!"
      }
    ]
  }
  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  return (
    <>
      <Helmet>
        <title>{Painting?.seo_title || Painting?.title_persian}</title>
        <meta name="description" content={Painting?.meta_description || Painting?.body?.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 600)} />
        <link rel="canonical" href={canonicalUrl} />
        <script type="application/ld+json">
          {JSON.stringify(generalSchema)}
        </script>
      </Helmet>
      <div className="container">
        <Breadcrumbs separator='/' className="py-6" itemClasses={{ separator: "px-2" }} dir="rtl">
          <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
          <BreadcrumbItem href='/product?page=1'>تابلوها</BreadcrumbItem>
          <BreadcrumbItem>{Painting.title_persian || Painting.title}</BreadcrumbItem>
        </Breadcrumbs>
        <div className="grid grid-cols-1 md:grid-cols-12 md:gap-3" ref={main}>
          <Article {...{ Painting, mainImage, width, height }} />
          <Aside {...{ Painting, setMainImage, mainImage, passpartout, setPasspartout, setWidth, setHeight, width, height }} />
        </div>
      </div>
      {!!Painting?.artist_related.length && <ArtSection
        id={1}
        initData={Painting?.artist_related}
        title={`دیگر آثار ${Painting.artist?.title}`}
        url={`/artists/${Painting.artist?.slug}`}
      />}
      {!!Painting?.category_related.length && <ArtSection
        id={2}
        initData={Painting?.category_related}
        title={`اثار دیگر در دسته ${Painting.category?.title}`}
        url={`/categories/${Painting.category?.slug}`}
      />}
      <ArtSection initData={Painting?.tag_related} title={"موارد پیشنهادی دیگر"} />
    </>
  );
}